/** Sentinel for bulk TLD "leave unchanged" in Edit Sent. */
export const LEAVE_TLD_UNCHANGED = '__unchanged__';
